<template>
  <div class="container-lg container-lg-custom">
    <div class="acciones-panel acciones-panel-custom">
      <button @click="clickNuevo()" type="button" class="btn btn-success">
        <span>Nuevo</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.AGREGAR" />
      </button>
      <Buscador :esBeneficio="esBeneficio" :onSearch="filtrarTabla"></Buscador>

    </div>
    <TablaComercios id="tablaComercios" ref="tablaComercios" :facade="Facade" :mostrarEditar="true"
      :mostrarEliminar="true" :busqueda="busqueda" :cargaManual="true"/>
  </div>
</template>

<script>
import { environment } from "../../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { ComercioFacade as Facade } from "../../admin/comercio/comercio.facade";
import { Icons as IconConstants } from "../../constants";
import TablaComercios from "./tablas/TablaComercios.vue";
import Buscador from "./tablas/util/Buscador";
import { Util } from "../../util";
import { BuscarPor, OrdenarPor } from "../../data/enums";

const bootstrap = require("bootstrap");

const COMERCIO_LIMPIO = {
  id: "",
  nombre: "",
  direccion: "",
  telefono: "",
  whatsapp: "",
  cuit: "",
  email: "",
  observaciones: "",
  localidad: {
    id: "",
    nombre: ""
  }
};

export default {
  components: {
    FontAwesomeIcon,

    Buscador,
    TablaComercios
  },
  data() {
    return {
      busqueda: {
        valor: null,
        buscarPor: BuscarPor.comercio,
        ordenarPor: OrdenarPor.relevancia
      },
      /**Comercio que está siendo creado o editado */
      // La copia profunda permite que los métodos Computed funcionen correctamente
      comercio: Util.copiaProfunda(COMERCIO_LIMPIO),
      /**Comercio que está siendo visto */
      comercioVisto: Util.copiaProfunda(COMERCIO_LIMPIO),
      // Usado para indicarle al componente buscador que es comercio
      esBeneficio: false,
      // Usado para mostrar animación de carga
      guardando: false,
      /**Modal para mostrar logos y QR */
      modalInfo: null,
      /**Usado para alternar el modal entre QR y logo */
      modoModalInfo: "", 
    };
  },
  computed: {
    /**
     * @returns {boolean} Verdadero si se está editando, falso si no
     */
    Editando() {
      return !!this.comercio.id;
    },
    Facade() {
      return Facade;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    UrlComercios() {
      return environment.URL_COMERCIOS_QR;
    }
  },
  methods: {
    // Cuando se quiere crear un item
    clickNuevo() {
      // Avisar que se quiere crear un item
      this.$refs.tablaComercios.EventoCrear();
    },
    /**Descarga el QR del comercio actual */
    descargarQR() {
      // Obtener el link de la imagen temporal generada por el componente de QR
      const imageLink = document.getElementById("qrRoot").src;

      // Crear un elemento temporal <a> para poder descargar
      let a = document.createElement("a");
      a.href = imageLink;

      // Nombre del archivo descargado
      a.download = this.comercioVisto.nombre + "QR" + ".png";
      document.body.appendChild(a);

      // Simular un click para descargar
      a.click();

      // Eliminar elemento temporal
      document.body.removeChild(a);
    },
    verLogo(comercio) {
      this.comercioVisto = comercio;
      this.modoModalInfo = "logo";
      this.modalInfo.show();
    },
    /**Muestra modal con el QR del comercio */
    verQR(comercio) {
      this.comercioVisto = comercio;
      this.modoModalInfo = "qr";
      this.modalInfo.show();
    },
    // Filtra la tabla segun la busqueda
    filtrarTabla(busqueda) {
      this.busqueda = busqueda;
      this.$refs.tablaComercios.EventoRecargar(busqueda);
    }
  },
  mounted() {
    const opcionesModal = {};
    this.modalInfo = new bootstrap.Modal(
      document.getElementById("modalInfo"),
      opcionesModal
    );

    this.$refs.tablaComercios.EventoRecargar(this.busqueda);
    
  }
};
</script>

<style lang="scss" scoped>
.logo-pond-panel {
  margin: 0;
}
.opciones-de-elemento {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
}

.filepond--root {
  max-height: 1em;
}

.modal-imagen {
  max-width: 100%;
  max-height: 100%;
}

.modal-qr-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-qr-container button {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.acciones-panel{
  justify-content: space-between;
}

@media screen and (min-width: 1400px) {
  
  .container-lg-custom{
    width: 90%;
  }
}
</style>
